import "./block.css";
import "./block-table.css";
import classNames from "classnames";
import { forwardRef, useEffect, useRef, useState } from "react";
import useResizeObserver from "use-resize-observer";
import { Icon } from "../icon/icon";
import UserActivityStatus from "../../components/user-activity-status/user-activity-status";
import { DeleteOutlined } from "@ant-design/icons";

export const BlockComponentBase = forwardRef(
  ({ children, style, fixThead, padding, className, accent = false }, ref) => {
    return (
      <div
        ref={ref}
        className={classNames("lf-block", className, {
          "lf-block--fix-thead": fixThead,
        })}
        style={{
          ...style,
          "--block-side-padding": padding ? `${padding}px` : "32px",
        }}
      >
        {accent && (
          <div className="lf-block__before">
            <div className="lf-block__before-inside" />
          </div>
        )}
        {children}
      </div>
    );
  }
);

export const BlockHeader = ({ title, size = "sm" , onClick}) => {
  return (
    <div onClick={onClick} className="lf-block-header" data-size={size} style={{cursor: onClick ? 'pointer' : 'default'}}>
      <h4>{title}</h4>
    </div>
  );
};

export const BlockSection = forwardRef((props,ref) => {
  return <div ref={ref} className={classNames("lf-block-section", props.className)} style={props.style}>{props.children}</div>;
});

export const BlockAdd = forwardRef(({ onClick, title, style, hide, hideIcon }, ref) => {
  return (
    <div className={classNames('lf-block-add',{'lf-block-add--hide': hide})} onClick={onClick} style={style}>
      {!hideIcon && (
        <Icon
          ref={ref}
          name={"add"}
          style={{marginRight:4}}
        />
      )}
        {title || "Add"}
    </div>
  );
});

export const BlockBadge = forwardRef(({ onClick, title, style, hide, hideIcon, status }, ref) => {
  return (
    <div
      className={classNames('lf-block-add', { 'lf-block-add--hide': hide })}
      onClick={onClick}
      style={{ padding: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', ...style }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {!hideIcon && (
          <Icon
            ref={ref}
            name="add"
            style={{ marginRight: 4 }}
          />
        )}
        {title}
      </div>
      <UserActivityStatus userStatus={status} />
    </div>
  )
})

export const BlockRow = forwardRef(({ onClick, onDelete, title, style }, ref) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={classNames("lf-block-row")}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {title}
      </div>
      {onDelete && hovered && (
        <DeleteOutlined
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          style={{
            marginLeft: 12,
            color: "#6C6C89",
            fontSize: 16,
            cursor: "pointer",
          }}
        />
      )}
    </div>
  );
});

export const BlockCollapse = ({ title, children, after }) => {
  const [isOpen, setOpen] = useState(false);
  const [isMount, setIsMount] = useState(false);
  const ref = useRef();
  const {height} = useResizeObserver({
    ref,
    box: 'border-box'
  });

  const toggleHandler = () => {
    if(isOpen){
      setIsMount(false);
      setTimeout(()=>{
        setOpen(false);
      },100)
    } else {
      setOpen(true);
      setTimeout(()=>{
        setIsMount(true);
      },1)
    }

  };

  useEffect(() => {
    console.log(height)
  }, [height]);

  return(
    <div className={classNames(
        'lf-block-collapse', {
          'lf-block-collapse--open': isOpen
        })}>
    <div
      className={'lf-block-collapse__header'}
      onClick={toggleHandler}
    >
      <Icon name={'arrow-right'} color={'text-2'}/>
      <div className='lf-block-collapse__title'>
        {title}
      </div>
      <div className='lf-block-collapse__after'>
        {after}
      </div>
    </div>
    {isOpen &&
      <div
        className={'lf-block-collapse__body'}
        style={{ height: isMount ? height + 24 : 0, }}
      >
        <div ref={ref}>
          {children}
        </div>
    </div>
    }
</div>
  )
}

export default Object.assign(BlockComponentBase, {
  Header: BlockHeader,
  header: BlockHeader,
  Section: BlockSection,
  section: BlockSection,
  Collapse: BlockCollapse
});
